const path = "categories";

export const FETCH_CATEGORIES_REQUEST = `${path}/FETCH_CATEGORIES_REQUEST`;
export const FETCH_CATEGORIES_SUCCESS = `${path}/FETCH_CATEGORIES_SUCCESS`;
export const FETCH_CATEGORIES_FAILURE = `${path}/FETCH_CATEGORIES_FAILURE`;
export const FETCH_CATEGORIES_CANCEL = `${path}/FETCH_CATEGORIES_CANCEL`;
export const CLEAR_CATEGORIES = `${path}/CLEAR_CATEGORIES`;
